/**
 *
 * Asynchronously loads the component for StockStatus
 *
 */

import { lazyLoad } from 'utils/loadable';

export const StockStatus = lazyLoad(
  () => import('./index'),
  module => module.StockStatus,
);
